import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(protected)/admin/(content)/emergency-broadcast": [6],
		"/admin/feedbacks/[id]": [9],
		"/(protected)/admin/(content)/ml-scanner": [7],
		"/ai-workflow": [10],
		"/alerts": [11],
		"/alerts/[id]": [12,[],[2]],
		"/analytics/energy-forecast": [13],
		"/approved-alerts": [14],
		"/dashboard": [15],
		"/dashboard/admin": [16],
		"/(protected)/dashboard/admin/data-explorer": [8],
		"/feedback": [17],
		"/field-tech": [18,[3]],
		"/field-tech/alerts": [19,[3]],
		"/field-tech/profile": [20,[3]],
		"/field-tech/schedule": [21,[3]],
		"/field-tech/session/[id]": [22,[3]],
		"/field-tech/tracking": [23,[3]],
		"/field-tech/work-orders": [24,[3]],
		"/field-tech/work-orders/[id]": [25,[3]],
		"/login": [26],
		"/logs": [27],
		"/ml-predictions": [28],
		"/my-feedback": [29],
		"/my-feedback/[id]": [30],
		"/password-reset": [31],
		"/profile": [32],
		"/reset-password": [~33],
		"/work-orders": [34],
		"/work-orders/[id]": [35,[],[4]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';